export default __webpack_public_path__ + "static/media/inventory.183a766e.jpg";